import Vue from 'vue';

export const supplierContactService = {
  async getSupplierContact(reference_number) {
    return Vue.axios.get('/supplier-contacts/' + reference_number);
  },
  async saveSupplierContact(supplierContact) {
    return Vue.axios.post('/supplier-contacts', supplierContact).then(response => response.data);
  }
};
